import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Pagination(theme: Theme) {
  return {
    MuiPagination: {
      defaultProps: {},
      styleOverrides: {
        root: {
          '& .MuiButtonBase-root': {
            backgroundColor: theme.palette.primary.contrastText,
          },
          '& .MuiButtonBase-root.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        },
      },
    },
    MuiPaginationItem: {
      defaultProps: {},
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
  }
}
